
import React, { Component } from "react";
import { Link } from "gatsby";
import '../css/footerstyle.css'
import Facebook from '../images/facebook-logo.svg'
import Twitter from '../images/twitter-logo.svg'
import Youtube from '../images/youtube-logo.svg'



class Footer extends Component {
  constructor() {
    super();
    this.state = {
     };
}


render(){
  return(
//     <div className="FooterMainSec">
//     <div className='footerstyle'>
//       <div className='row'>
//       <div className='col-md-6' style={{'padding-inline-end': '10%'}}>
//         <div>
//           <img data-src="https://res.cloudinary.com/image/upload/v1602062714/Home/twin-footer-logo_puztix.png"  className="lazyload" id="footer_logo" alt='no footer logo'/>
//         </div>
//         <p className='footer-text'>
//         Twin Health is a precision health company which invented & is using the Whole Body Digital TwinTM technology to detect, measure & reverse chronic diseases to help its program members live healthier, happier lives.The Digital Twin treatment is offered by a large panel of Indian Medical Council approved Doctors, endocrinologists and diabetologists.

// Twin Health Inc. is based in California, USA with subsidiary offices in Chennai, Bangalore and was founded by Jahangir Mohammed in 2018. He is a world-renowned technology inventor and has over 100 patents to his name.
//         </p>
//       </div>
//       <div className="web-footer">
//       <div className='col-md-3'>
//         <ul className='footer_links'>
//           <li id='links'>Treatment</li>
//           <li id='links'>Doctors</li>
//           <li id='links'>Technology</li>
//           <li id='links'>How it works</li>
//           <li id='links'>Patient Care</li>
//           <li id='links'>Terms and Condition</li>
//         </ul>
//       </div>
     
//       <div className='col-md-3'>
//       <ul className='footer_links'>
//           <li id='links'>Privacy Policy</li>
//           <li id='links'>Payment Modes</li>
//           <li id='links'>Refunds</li>
//           <li id='links'>Support </li>
//           <li id='links'>Connect With Us On</li>
//           <div >
//           <a href="https://www.facebook.com/TwinForHealth" target="_blank"><img src={Facebook} alt='no facebook link' className='social_icons'/></a>
//           <img src={Twitter} alt='no facebook link' className='social_icons'/>
//           <img src={Youtube} alt='no facebook link' className='social_icons'/>
          
//           </div>
//         </ul>
//       </div>
//       </div>
//      </div>
     
//     </div>
//     <div className="m-footer">
//         <div className='row col-md-12' style={{margin:"0px"}}>
//           <div className='col-md-6' style={{width:"60%",float:"left",padding:"0px"}}>
//           <ul className='footer_links'>
//           <li>Privacy Policy</li>
//           <li>Payment Modes</li>
//           <li>Refunds</li>
//           <li>Terms and Condition</li>
//           <li>Support </li>
//             </ul>
//           </div>
//           <div className='col-md-6' style={{position:"relative",top:"-6px"}}>
//           <ul className='footer_links'>
//           <li>Connect with Us</li>
//           </ul>
//           <div >
//           <a href="https://www.facebook.com/TwinForHealth" target="_blank"><img src={Facebook} id="m-icons" alt='no facebook link' className='social_icons'/></a>
//           <a href="" target="_blank"><img src={Twitter} id="m-icons" alt='no facebook link' className='social_icons'/></a>
//           <a href="" target="_blank"><img src={Youtube} id="m-icons" alt='no facebook link' className='social_icons'/></a>
          
//           </div>
//           </div>
//         </div>
//       </div>
//     <div className='rights_reserved'>
//        <p >2020 Twin Health | All Rigts Reserved</p>
//      </div>
//   </div>
<div className="FooterMainSec row col-md-12">
<div className='footerstyle'>
  <div className='row col-md-12'>
  <div className='col-md-7' style={{'padding-inline-end': '10%'}}>
    <div className="footerleft">
      <img data-src="https://res.cloudinary.com/image/upload/v1603353606/Diabetes/twin-health-logo-1_qoeygp.png"  className="lazyload imgWidthgFooter" id="footer_logo" alt='no footer logo'/>
      <p className="footer-text">
      Twin Health is a precision health company which invented & is using the Whole Body Digital TwinTM technology to detect, measure & reverse chronic diseases to help its program members live healthier, happier lives.The Digital Twin treatment is offered by a large panel of Indian Medical Council approved Doctors, endocrinologists and diabetologists.<br/><br/>

Twin Health Inc. is based in California, USA with subsidiary offices in Chennai, Bangalore and was founded by Jahangir Mohammed in 2018. He is a world-renowned technology inventor and has over 100 patents to his name.
      </p>
    </div>
    
  </div>
  <div className="col-md-5 footerRight">
    <ul className="footerAdd">
      <li className="listFooter">
        <b>Twin Health, Inc.</b><br/>
        2525 East Charleston Road,<br/>
        Suite 104, Mountain View,<br/>
        CA 94043, USA
      </li>
      <li className="listFooter">
        <b>Twins Digital Services India Private Limited</b><br/>
        Block D,  3rd Floor,<br/>
        IIT Madras Research Park,<br/>
        Kanagam Road, Taramani,<br/>
        Chennai  600 113, India
      </li>
      <li className="listFooter">
      <b>Twins Digital Services India Private Limited</b><br/>
      2nd Floor, 418 & 420,  4th Cross Road,<br/>
      HRBR Layout 2nd Block,<br/>
      Kalyan Nagar,<br/>
      Bengaluru 560043, India
      </li>
    </ul>
  </div>
  
 </div>
 
</div>
<div className='rights_reserved'>
   <p >2020 Twin Health | All rights reserved</p>
 </div>

</div>
  )
}

}

export default Footer;

  
  

  



  

 
  
 